// const pages = ['https://4e7ba2-4.myshopify.com/collections/all'];

// (function($) {
//     pages.forEach(item => {
//         if(document.location.href.indexOf(item) >=0)  {
//             $('body').addClass('collection_page');
//         }
//     });
// }(jQuery));

$(document).ready(function() {
    // Check if the current page is a collection page
    if (window.location.pathname.indexOf('/collections/') !== -1) {
      // Add the 'testclass' to the body element
      $('body').addClass('collection_page');
    }
  });



// $('.product__media-list').slick({
//   centerMode: true,
//   centerPadding: '60px',
//   slidesToShow: 3,
  
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });


// var imgElement = document.querySelector('.image-magnify-lightbox');
// if (imgElement) {
//     imgElement.classList.add('zoomslider');
// }
// imgElement.addEventListener('click', function() {
//   console.log('testing');
//   var modal = document.getElementById('exampleModal');
//   if (modal) {
//   var modalInstance = new bootstrap.Modal(modal);
//   console.log('Image loaded');
//   modalInstance.show();
//   }
// });
// document.addEventListener('DOMContentLoaded', function() {
//     // Select the element with the class name 'gfb-style-classic'
//     const element = document.querySelector('.gfb-style-classic');

//     // Add a click event listener to the element
//     element.addEventListener('click', function() {
//         // Add the class 'contact-class' when the element is clicked
//         element.classList.add('contact-class');
//     });
// });



// window.addEventListener('load', function() {
//     // Select the element with the class name 'gfb-style-classic'
//     const element = document.querySelector('.gfb-style-classic');

//     // Set a timeout to add the ID 'testing-id' after 2000 milliseconds (2 seconds)
//     setTimeout(() => {
//         element.setAttribute('id', 'cnctpg_form');
//     }, 100);
// });

window.addEventListener('load', function() {
    // Select the <p> element with the specific inline style
    const paragraphElement = document.querySelector('p[style="text-align: right;font-size:small;display: block !important;"]');

    // Check if the element exists before attempting to remove it
    if (paragraphElement) {
        // Store the reference to the <p> element in a variable
        const removedElement = paragraphElement.cloneNode(true);

        // Remove the <p> element from the DOM
        paragraphElement.parentNode.removeChild(paragraphElement);

        // Now you can use the variable `removedElement` to refer to the removed element
        console.log("Removed element:", removedElement);
    }
});


// setTimeout(() => {
//   const successMessage = document.querySelector('.message.success');
//   if (successMessage) {
//   successMessage.style.display = 'none !important';
//   }
// }, 5000);


